export default __webpack_public_path__ + "static/media/483.910b9947.png";